import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
    actions: {
      textAlign: "center",
      color: "#667085",
      fontFamily: "Manrope",
      fontSize: "12px",
      fontWeight: 700,
      lineHeight: "16px",
    },
    containerActions: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      paddingLeft: "5px",
    },
    checkboxCell: { width: "50px" },
    columnChooser: {
      position: "absolute",
      right: "5px",
      top: "50%",
      transform: "translateY(-13px)",
      zIndex: 103,
    },
  }));

export default styles;
